import { useState } from "react";
import { Loader2 } from "lucide-react";

export const PHQ9_QUESTIONS = [
    "Little interest or pleasure in doing things",
    "Feeling down, depressed, or hopeless",
    "Trouble falling or staying asleep, or sleeping too much",
    "Feeling tired or having little energy",
    "Poor appetite or overeating",
    "Feeling bad about yourself — or that you are a failure or have let yourself or your family down",
    "Trouble concentrating on things, such as reading or watching television",
    "Moving or speaking so slowly that other people could have noticed? Or the opposite — being so fidgety or restless that you have been moving around a lot more than usual",
    "Thoughts that you would be better off dead or of hurting yourself in some way",
];

const OPTIONS = [
    { v: 0, label: "Not at all" },
    { v: 1, label: "Several days" },
    { v: 2, label: "More than half the days" },
    { v: 3, label: "Nearly every day" },
];

const Q10_OPTIONS = ["Not difficult at all", "Somewhat difficult", "Very difficult", "Extremely difficult"];

export const PHQ9Form = ({ onSubmit, submitting, submitLabel = "Submit PHQ-9" }) => {
    const [answers, setAnswers] = useState({});
    const [q10, setQ10] = useState("");
    const complete = PHQ9_QUESTIONS.every((_, i) => answers[`q${i + 1}`] !== undefined) && !!q10;

    return (
        <div data-testid="phq9-form" className="space-y-5">
            <p className="text-sm text-muted-foreground leading-relaxed">
                Over the <strong>last 2 weeks</strong>, how often have you been bothered by any of the following problems?
            </p>
            {PHQ9_QUESTIONS.map((q, i) => {
                const key = `q${i + 1}`;
                return (
                    <div key={key} data-testid={`phq9-${key}`} className="space-y-2">
                        <div className="text-sm font-medium text-phoenix-navy">{i + 1}. {q}</div>
                        <div className="grid grid-cols-2 sm:grid-cols-4 gap-1.5">
                            {OPTIONS.map((o) => (
                                <button
                                    key={o.v}
                                    type="button"
                                    data-testid={`phq9-${key}-${o.v}`}
                                    onClick={() => setAnswers((a) => ({ ...a, [key]: o.v }))}
                                    className={`px-2 py-2 rounded-lg text-xs font-medium border transition-colors ${
                                        answers[key] === o.v
                                            ? "bg-phoenix-navy text-white border-phoenix-navy"
                                            : "bg-white text-muted-foreground border-border hover:border-phoenix-navy/40"}`}
                                >
                                    {o.label}
                                </button>
                            ))}
                        </div>
                    </div>
                );
            })}
            <div className="space-y-2 pt-2 border-t border-border/60">
                <div className="text-sm font-medium text-phoenix-navy">
                    If you checked off any problems, how difficult have they made it for you to do your work, take care of things at home, or get along with other people? <span className="text-red-500">*</span>
                </div>
                <div className="grid grid-cols-2 sm:grid-cols-4 gap-1.5">
                    {Q10_OPTIONS.map((o) => (
                        <button key={o} type="button" data-testid={`phq9-q10-${o.replace(/\s+/g, "-").toLowerCase()}`}
                            onClick={() => setQ10(o)}
                            className={`px-2 py-2 rounded-lg text-xs font-medium border transition-colors ${
                                q10 === o ? "bg-phoenix-navy text-white border-phoenix-navy" : "bg-white text-muted-foreground border-border hover:border-phoenix-navy/40"}`}>
                            {o}
                        </button>
                    ))}
                </div>
            </div>
            <button
                data-testid="phq9-submit"
                disabled={!complete || submitting}
                onClick={() => onSubmit({ answers, q10: q10 || null })}
                className="w-full px-4 py-3 bg-phoenix-navy text-white text-sm font-semibold rounded-xl hover:bg-phoenix-navy-2 disabled:opacity-50 transition-all"
            >
                {submitting ? <Loader2 className="w-4 h-4 animate-spin inline" /> : submitLabel}
            </button>
            {!complete && <p className="text-xs text-muted-foreground text-center">Answer all 9 questions and the final difficulty question to continue.</p>}
        </div>
    );
};
